import { createClient } from '@supabase/supabase-js';

const defaultUrl = 'https://hkzfyiytzofmjsdedqhg.supabase.co';
const defaultPublishableKey = 'sb_publishable_IDdBCmmwiwRK1R7w-choDg_RbgtXUlm';

const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined) || defaultUrl;
const key = (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined) || defaultPublishableKey;

export const supabase = createClient(url, key);
export const backendConfigured = true;
